import PropTypes from 'prop-types';
import React from 'react';
import envConfig from 'trade-in-360/config/index.js';
import CBBAutoComplete from 'trade-in-360/components/CBBAutoComplete/CBBAutoComplete.jsx';
import { ContentZonesService } from '@sm360/widget-commons-core-services';
import { Quote } from '@sm360/widget-commons-vehicle';

const NewInstantEstimateAutocomplete = ({
    onAutoCompleteSelect,
    selectedValue,
    parentClassName,
    config,
    isBarWrapper,
    isShowroomV2Enabled,
    quote,
}) => {
    const czGroup = 'widget.tradein.teaser';

    const mainImage = ContentZonesService.getContentZone(czGroup, 'appraisal.main.image')
        ? ContentZonesService.getContentZone(czGroup, 'appraisal.main.image').getValue()
        : undefined;

    const imagesServer = envConfig.source.image;
    const isDisplaySquareImage =
        (isShowroomV2Enabled && !isBarWrapper) || (!isShowroomV2Enabled && parentClassName === '');
    return (
        <div className="instant-estimate__content">
            <div className={`instant-estimate__text-content ${isDisplaySquareImage && 'squareImg'}`}>
                {mainImage && <img src={mainImage} alt="main-tradein__image" className="main-tradein__image" />}
                {(isShowroomV2Enabled && !isBarWrapper) || (!isShowroomV2Enabled && parentClassName === '') ? (
                    // Display square image for v2 - VLP and Homepage
                    // Display square image for V2.5 - Homagepage and standalone
                    <img
                        src={`${imagesServer}/images/var/images/widget/showroom/asset/CBB-square-2022.png`}
                        alt="Black Book"
                        className="teaser-cbb__image square"
                    />
                ) : (
                    <img
                        src={`${imagesServer}/images/var/images/widget/showroom/asset/CBB_powered_by_2022.png`}
                        alt="Black Book"
                        className="teaser-cbb__image"
                    />
                )}
                <CBBAutoComplete
                    onValueSelected={onAutoCompleteSelect}
                    value={selectedValue}
                    dataTestPrefix="trade-in.instant-estimate-autocomplete"
                    parentClassName={parentClassName}
                    config={config}
                    isBarWrapper={isBarWrapper}
                    quote={quote}
                />
            </div>
        </div>
    );
};

NewInstantEstimateAutocomplete.defaultProps = {
    config: {},
    isBarWrapper: false,
    quote: new Quote.QuoteModel(),
};

NewInstantEstimateAutocomplete.propTypes = {
    onAutoCompleteSelect: PropTypes.func.isRequired,
    selectedValue: PropTypes.string.isRequired,
    parentClassName: PropTypes.string.isRequired,
    config: PropTypes.object,
    isBarWrapper: PropTypes.bool,
    quote: PropTypes.instanceOf(Quote.QuoteModel),
};

NewInstantEstimateAutocomplete.displayName = 'NewInstantEstimateAutocomplete';

export default NewInstantEstimateAutocomplete;
